.recursive {
  padding: 12px;
  margin-bottom: 18px;

  .recursiveLabel {
    margin-bottom: 11px;
    font-size: 2rem;
    line-height: 1;
    font-weight: 450;
  }

  .description {
    padding: 0 27px;

    @media screen and (min-width: 768px) {
      display: flex;
      align-items: flex-start;
    }
  }

  .descriptionHidden {
    visibility: hidden;
  }

  .recursiveDescriptionColumn {
    @media screen and (min-width: 768px) {
      flex: 0 0 50%;

      &:first-child {
        margin-right: 10px;
      }
    }
  }

  .recursiveDescriptionLabel {
    margin-bottom: 8px;
  }

  .recursiveDescriptionInput {
    border-radius: 3px;
    background-color: var(--color-grey-8);
    padding: 6px;
    height: 35px;
    display: flex;
    align-items: center;
  }

  .recursiveDescriptionIcon {
    margin-bottom: 3px;
    margin-right: 2px;
  }

  .recursiveDescriptionSecurityIcon {
    font-size: 2.5rem;
    line-height: 2.34rem;
    margin-right: 2px;
  }

  .recursiveRestricted {
    line-height: 2rem;
    height: 35px;
  }
}
